module.exports = __webpack_public_path__ + "static/img/ycscsd.f63e197.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/ycscsd.png
// module id = AF3v
// module chunks = 0